import { render, staticRenderFns } from "./AddBankOverlay.vue?vue&type=template&id=651b0746&"
import script from "./AddBankOverlay.vue?vue&type=script&lang=js&"
export * from "./AddBankOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports